import React from "react";
import Hero from "../components/Hero";
import Reviews from "../components/Reviews";

function Home() {
  return (
    <>
      <Hero />
      <Reviews />
    </>
  );
}

export default Home;
